import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash';
import moment from 'moment';
import 'moment/locale/ko'


import {
  Container,
  Row,
  Button,
  Col,
  FormGroup,
  Input,
  Spinner
} from 'reactstrap';

import { useFirebase, useFirestore, useFirestoreConnect } from 'react-redux-firebase';
import { useSelector } from 'react-redux';
import defaultAvatar from "assets/img/placeholder.jpg";
import { truncateString } from 'helpers/string';

function MessageForm(props) {

  const [message, setMessage] = useState(props.currentItem || {});
  const [errorMessage, setErrorMessage] = useState(null);
  const [onSaving, setOnSaving] = useState(false);
  const [messageId, setMessageId] = useState(props.currentItem?.id || null);

  const firebase = useFirebase();
  const firestore = useFirestore();

  const uid = useSelector(state => state.auth.currentUser.uid);
  const currentUser = useSelector(state => state.auth.currentUser);

  useFirestoreConnect([
    {
      collection: `message_groups/${props.messageGroup?.id}/messages`,
      orderBy: [
        ['created_at', 'desc']
      ],
      storeAs: 'messages'
    }
  ]);

  const messages = useSelector(state => state.firestore.ordered.messages);
  console.log('messages = ', messages);

  useEffect(() => {
    console.log('props.messageGroup = ', props.messageGroup);
    if (props.currentItem?.id) {
      setMessageId(props.currentItem.id);
    } else {
      setMessageId(firestore.collection(`message_groups/${props.messageGroup?.id}/messages`).doc().id);
    }

    return () => {
      // cleanup
    }
  }, []);

  useEffect(() => {
    if (props.currentItem) {
      const _message = _.clone(props.currentItem);
      delete _message.id;
      setMessage(_message);
    }
    return () => {
      // cleanup
    }
  }, [props.currentItem]);

  useEffect(() => {
    if (message.content?.length > 9) {
      setErrorMessage('');
    } else {
      setErrorMessage('내용을 입력하시면 보내기 버튼이 활성됩니다.');
    }
    return () => {
      // cleanup
    }
  }, [message.content])

  const checkValidity = () => {

  }

  const onSave = async () => {
    console.log('press save');

    setOnSaving(true);

    const author = {
      name: currentUser.displayName,
      profile_image_url: currentUser.photoURL,
      user_id: uid,
    }

    const timestamp = {
      updated_at: firestore.FieldValue.serverTimestamp()
    }

    if (!props.currentItem?.id) {
      timestamp['created_at'] = firestore.FieldValue.serverTimestamp();
    }

    try {
      const content = _.clone(message.content);
      setMessage({ ...message, content: '' });
      console.log('path1 = ', `message_groups/${props.messageGroup?.id}`);
      const messageGroupRef = firestore.doc(`message_groups/${props.messageGroup?.id}`);
      if (props.messageGroup?.created_at) {
        await messageGroupRef.update({
          last_message: truncateString(content, 200),
          updated_at: firestore.FieldValue.serverTimestamp()
        });
      } else {
        await messageGroupRef.set({
          ...props.messageGroup,
          last_message: truncateString(content, 200),
          updated_at: firestore.FieldValue.serverTimestamp(),
          created_at: firestore.FieldValue.serverTimestamp(),
        });
      }
      console.log('path2 = ', `message_groups/${props.messageGroup?.id}/messages`);
      const messageRef = firestore.collection(`message_groups/${props.messageGroup?.id}/messages`).doc(messageId);
      await messageRef.set({
        author,
        content,
        ...timestamp,
      });
    } catch (error) {
      console.error('Failed to save : ', error);
    }
    setOnSaving(false);
  }

  const onCancel = () => {
    props.toggle();
  }


  const onChange = (e, name, typeFn) => {
    const value = e.target.value;
    setMessage({ ...message, [name]: typeFn ? typeFn(value) : value });
  }

  const renderMessage = (message) => {
    return <div key={message.id} className='p-1'>
      <Row className='d-flex align-items-baseline'>
        <Col xs={{ size: 'auto' }}>
          {renderProfile(message.author)}
        </Col>
        <Col>
          <div>
            {message.content.split('\n').map((line, idx) => <p key={idx}>{line}</p>)}
          </div>
          <div className='text-right text-secondary font-italic'>
            {moment(message.updated_at?.toDate()).format('YYYY년 MM월 DD일 A hh:mm')} 작성
          </div>
        </Col>
      </Row>
    </div>
  }

  const renderProfile = (member) => {
    return <div key={member.uid}>
      <img
        src={!member.profile_image_url || member.profile_image_url.length === 0 ? defaultAvatar : member.profile_image_url}
        className='rounded-circle'
        alt='profile'
        style={{ width: 42, height: 42 }}
      />
      <span className='ml-1 p-1 font-weight-bold'>{member.name}</span>
    </div>
  }


  return (
    <Container className='p-5'>
      <Row>
        <Col>
          {
            messages?.map(message => renderMessage(message))
          }
          <Row className='mt-3'>
            <Col xs={9}>
              <FormGroup className='ml-3'>
                <Input
                  type='textarea'
                  value={message.content}
                  onChange={e => onChange(e, 'content')}
                />
              </FormGroup>
            </Col>
            <Col>
              <Button onClick={onSave} disabled={onSaving || !message.content || message?.content?.length < 10} className='d-inline-flex'>
                보내기
                {
                  onSaving
                    ? <Spinner color='primary' />
                    : null
                }
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className='text-danger'>{errorMessage}</div>
            </Col>
          </Row>
        </Col>
      </Row>

    </Container>
  )
}

MessageForm.propTypes = {
  messageGroup: PropTypes.object.isRequired,
  message: PropTypes.object
}

export default MessageForm

